import React from "react";
import TrinsicStart from "../trinsic/TrinsicStart";
import MojeIdLogo from "../../../assets/mojeid-logo.png";
import {
  IconShieldCheck,
  IconLock,
  IconUserCheck,
  IconFingerprint,
} from "@tabler/icons-react";

const mojeIdFeatures = [
  { icon: IconUserCheck, text: "Verified identity in seconds" },
  { icon: IconLock, text: "Your credentials stay private" },
  { icon: IconShieldCheck, text: "Trusted by 1.2M+ users" },
];

const MojeIdStart = () => {
  return (
    <TrinsicStart
      providerName="MOJEID"
      providerDisplayName="mojeID"
      logo={MojeIdLogo}
      logoWidth={50}
      buttonColor="#ffcb00"
      title="Verify Your Identity"
      TitleIcon={IconFingerprint}
      features={mojeIdFeatures}
    />
  );
};

export default MojeIdStart;
